import React,{useEffect,useState} from "react";
import {useNavigate} from "react-router-dom";
import API from "../services/api";
import InvoiceTable from "../InvoiceTable";
import "../styles/Invoice.css";

export default function UserExpense(){

const navigate=useNavigate();

const employeeName=
localStorage.getItem("username");

const [rows,setRows]=useState([]);

const [search,setSearch]=useState("");
const [month,setMonth]=useState("");
const [year,setYear]=useState("");

useEffect(()=>{

setRows([
{
id:Date.now(),
invoiceNo:
Math.floor(
1000+
Math.random()*9000
),
customerName:
employeeName,
isEditing:true,
subItems:[
{
date:"",
category:"",
description:"",
quantity:1,
amount:0,
total:0
}
]
}
]);

},[]);

const handleChange=(id,field,value)=>{

setRows(

rows.map(row=>

row.id===id
?
{
...row,
[field]:value
}
:
row

)

);

};

const handleSubChange=(

rowId,
index,
field,
value

)=>{

const updated=[...rows];

const row=
updated.find(
r=>r.id===rowId
);

row.subItems[index][field]=value;

const item=
row.subItems[index];

item.total=

(Number(item.quantity)||0)

*

(Number(item.amount)||0);

setRows(updated);

};

const addSubItem=(id)=>{

const updated=[...rows];

const row=
updated.find(
r=>r.id===id
);

row.subItems.push({

date:"",
category:"",
description:"",
quantity:1,
amount:0,
total:0

});

setRows(updated);

};

const deleteSubItem=(id,index)=>{

const updated=[...rows];

const row=
updated.find(
r=>r.id===id
);

row.subItems.splice(index,1);

setRows(updated);

};

const handleEdit=(id)=>{

setRows(

rows.map(row=>

row.id===id
?
{
...row,
isEditing:true
}
:
row

)

);

};

const handleSave=(id)=>{

setRows(

rows.map(row=>

row.id===id
?
{
...row,
isEditing:false
}
:
row

)

);

};

const handleCancel=(id)=>{

setRows(

rows.map(row=>

row.id===id
?
{
...row,
isEditing:false
}
:
row

)

);

};

const deleteRow=(id)=>{

setRows(

rows.filter(
row=>row.id!==id
)

);

};
const submitExpense=async()=>{

try{

const res=await API.post(
"/expense",
rows[0]
);

console.log(res.data);

alert(
"Expense Submitted Successfully"
);

}catch(err){

console.log(
err.response?.data ||
err.message
);

alert(
"Expense Submit Failed"
);

}

};
const filteredRows=
rows.filter(row=>{

if(!search)
return true;

return row.subItems.some(item=>

(item.category||"")
.toLowerCase()
.includes(
search.toLowerCase()
)

);

});

return(

<div className="container">

<h1>
User Expense
</h1>

<div
className="expense-filters"
>

<input
type="text"
placeholder="Search Category"
value={search}
onChange={(e)=>
setSearch(e.target.value)
}
/>

<select
value={month}
onChange={(e)=>
setMonth(e.target.value)
}
>

<option value="">
All Months
</option>

<option value="01">
Jan
</option>

<option value="02">
Feb
</option>

<option value="03">
Mar
</option>

<option value="04">
Apr
</option>

<option value="05">
May
</option>

<option value="06">
Jun
</option>

<option value="07">
Jul
</option>

<option value="08">
Aug
</option>

<option value="09">
Sep
</option>

<option value="10">
Oct
</option>

<option value="11">
Nov
</option>

<option value="12">
Dec
</option>

</select>

<select
value={year}
onChange={(e)=>
setYear(e.target.value)
}
>

<option value="">
All Years
</option>

<option value="2025">
2025
</option>

<option value="2026">
2026
</option>

</select>

<button
className="add-expense-btn"
onClick={()=>{

setRows([
...rows,
{
id:Date.now(),
invoiceNo:
Math.floor(
1000+
Math.random()*9000
),
customerName:
employeeName,
isEditing:true,
subItems:[
{
date:"",
category:"",
description:"",
quantity:1,
amount:0,
total:0
}
]
}
]);

}}
>

Add Expense

</button>

</div>

<InvoiceTable

rows={filteredRows}

handleChange={handleChange}

handleEdit={handleEdit}

handleSave={handleSave}

handleCancel={handleCancel}

deleteRow={deleteRow}

addSubItem={addSubItem}

handleSubChange={handleSubChange}

deleteSubItem={deleteSubItem}

/>

<div
style={{
marginTop:"20px"
}}
>

<button
className="submit-btn"
onClick={submitExpense}
>

Submit Expense

</button>

<button

style={{
marginLeft:"10px"
}}
className="view-btn"
onClick={()=>
navigate(
"/submittedexpenses"
)
}

>

Submitted Expenses

</button>

</div>

</div>

);

}